import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  CssBaseline,
  Stack,
  Typography,
  Grid,
  TextField,
  InputAdornment
} from '@mui/material';
import { Search } from '@mui/icons-material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { MdArrowDropDown } from 'react-icons/md';
import fakeArrayDelete from '../../../services/fakeArrayDelete';
// import Validation from '../../global/Validation';
import Loader from '../../global/Loader';
import PageHeading from '../../global/header/PageHeading';
import onBoardingEkycServices from '../../../services/onBoarding-ekyc-services';

const { GetFaq } = onBoardingEkycServices;

// const { GetFaq } = fakeArrayDelete;

const Faq = () => {
  const [getFaqResponse, setGetFaqResponse] = useState([]);
  const [getFaqResponseForSearch, setGetFaqResponseForSearhc] = useState([]);
  const [openValidation, setOpenValidation] = useState(false);
  const [validationMsg, setValidationMsg] = useState('');
  const [openloader, setOpenLoader] = useState(false);

  const handleClose = () => {
    setOpenValidation(false);
  };
  // Filter Search
  const handleSearch = (e) => {
    const txtvalue = e.target.value;
    const filtredData = getFaqResponseForSearch.filter((item) => {
      let currentItem = '';
      if (item.faqTitle || item.faqAnswer) {
        if (
          item.faqTitle.includes(txtvalue) ||
          item.faqAnswer.includes(txtvalue)
          // ||
          // encodeURIComponent(item.faqAnswer).includes(encodeURIComponent(txtvalue))
        ) {
          currentItem = item;
        }
      }

      return currentItem;
    });

    setGetFaqResponse(
      filtredData.length > 0
        ? filtredData
        : [
            {
              faqTitle: 'No search results found',
              faqAnswer: null
            }
          ]
    );
  };

  // get consents api
  const GetFaqApi = async () => {
    try {
      setOpenLoader(true);
      const GetFaqResponse = await GetFaq();
      if (GetFaqResponse.status === 'Success' && GetFaqResponse.data.length > 0) {
        // console.log('GetFaqResponse', GetFaqResponse);
        setGetFaqResponse(GetFaqResponse.data);
        setGetFaqResponseForSearhc(GetFaqResponse.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setOpenLoader(false);
    }
  };
  // const GetFaqApi = async () => {
  //   try {
  //     // const GetFaqResponse = await GetFaq();
  //     const isGetFaqResponse = GetFaq();
  //     setGetFaqResponse(isGetFaqResponse);
  //     setGetFaqResponseForSearhc(isGetFaqResponse);
  //     // if (GetFaqResponse.status === 'Success') {
  //     //   setOpenLoader(false);
  //     //   setGetFaqResponse(filtredByLang);
  //     //   setGetFaqResponseForSearhc(filtredByLang);
  //     // }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     setOpenLoader(false);
  //   }
  // };

  useEffect(() => {
    GetFaqApi();
  }, []);
  return (
    <>
      <PageHeading pageTitle="FAQ" />
      <Container maxWidth="lg" className="selfRegistrationContainer">
        <Loader openloader={openloader} />
        {/* <Validation
          openValidation={openValidation}
          validationMsg={validationMsg}
          handleClose={handleClose}
          setOpenValidation={setOpenValidation}
        /> */}

        <Box className="gblSearch">
          <TextField
            // className="gblSearchField"
            placeholder="search"
            inputProps={{ className: 'formControl' }}
            type="text"
            fullWidth
            // label="Outlined"
            variant="outlined"
            onChange={(e) => handleSearch(e)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search style={{ color: '#03989a' }} />
                </InputAdornment>
              )
              // className: 'searchLG'
            }}
          />
        </Box>
        {/* Search field start from here */}
        <Stack wordSpacing="5px" className="mainFAQ">
          {getFaqResponse.length > 0
            ? getFaqResponse.map((item, index) => {
                if (item.isShow === true) {
                  return (
                    <>
                      <Accordion className="accordionFAQ" classes={{ expanded: 'accordionFAQExp' }}>
                        <AccordionSummary
                          expandIcon={<MdArrowDropDown className="expandIcon" />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          className="accordionInnerFaq"
                          classes={{ expanded: 'accordionInnerFaqExp' }}
                        >
                          <Typography variant="h6" className="faqHeading">
                            {item.faqTitle}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography variant="body2" className="FormLabelText">
                            {item.faqAnswer}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    </>
                  );
                } else {
                  return '';
                  // return (
                  //   <Typography variant="h5" style={{ textAlign: 'center' }}>
                  //     'No search results found'
                  //   </Typography>
                  // );
                }
              })
            : ''}
        </Stack>
        {/* <Stack wordSpacing="5px" className="mainFAQ">
          {getFaqResponse.length > 0
            ? getFaqResponse.map((item, index) => {
                if (item.isShow === true) {
                  return (
                    <>
                      <Accordion className="accordionFAQ">
                        <AccordionSummary
                          expandIcon={<MdArrowDropDown className="expandIcon" />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                          className="accordionInnerFaq"
                        >
                          <Typography variant="h6" className="faqHeading">
                            {item.faqTitle}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography variant="body2" className="FormLabelText">
                            {item.faqAnswer}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    </>
                  );
                } else {
                  return (
                    <Typography variant="h5" style={{ textAlign: 'center' }}>
                      'No search results found'
                    </Typography>
                  );
                }
              })
            : ''}
        </Stack> */}
      </Container>
    </>
  );
};

export default Faq;
